import React from 'react';
import Box from '@/Atoms/Box';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import RenewalBanner from '@/Screens/Renewal/components/RenewalBanner';
import GlobalSchoolBanner from './GlobalSchoolBanner';
import {BannerType, RenewalBannerData} from '../hooks/useTopBanner';
import {Linking} from 'react-native';

interface TopBannerRendererProps {
  activeBanner: BannerType;
  renewalBannerData: RenewalBannerData | null;
  isLoading?: boolean;
}

const TopBannerRenderer: React.FC<TopBannerRendererProps> = ({
  activeBanner,
  renewalBannerData,
  isLoading = false,
}) => {
  const {isMobileOrTab} = useMediaQuery();

  if (isLoading || !activeBanner) {
    return null;
  }

  if (activeBanner === 'renewal' && renewalBannerData) {
    return (
      <Box
        style={{paddingHorizontal: isMobileOrTab ? 10 : 20, marginBottom: 15}}>
        <RenewalBanner
          daysLeft={renewalBannerData?.daysLeft ?? 0}
          sessionsLeft={renewalBannerData?.sessionsLeft ?? 0}
          expiryDate={renewalBannerData?.expiryDate}
          couponCode={renewalBannerData?.couponCode}
          couponDiscountPercentage={
            renewalBannerData?.couponDiscountPercentage ?? 0
          }
          challengeCompleted={renewalBannerData?.challengeCompleted ?? false}
          onClose={renewalBannerData.onClose}
          onEarnDiscount={renewalBannerData.onEarnDiscount}
        />
      </Box>
    );
  }

  if (activeBanner === 'global_school') {
    return (
      <Box
        style={{paddingHorizontal: isMobileOrTab ? 10 : 20, marginBottom: 15}}>
        <GlobalSchoolBanner
          onEnroll={() => {
            Linking.openURL('https://circlechess.com/play-to-win');
          }}
        />
      </Box>
    );
  }

  return null;
};

export default TopBannerRenderer;
